import dateTimeFormatter from 'mrf/utils/DateTimeFormatter';
import ListCRUD from 'mrf/view/ListCRUD';
import React from 'react';
import {useTranslation} from "react-i18next";

export default function CommunicationProcessList({ match }) {

    const {t} = useTranslation();

    const fields = [
        { name: t('Code'), key: 'id' },
        { name: t('Importing Country'), keys: ['importingCountry', 'institution', 'country', 'name'] },
        { name: t('Exporting Country'), keys: ['exportingCountry', 'institution', 'country', 'name'] },
        { name: t('Created at'), key: 'recordTimestamp', map: dateTimeFormatter },
        { name: t('Last Update'), key: 'updatedTimestamp', map: dateTimeFormatter },
        { name: t('Status'), keys: ['currentProcessStatus', 'name'], map:t },
        { name: t('Data Removal Date'), key: 'dataRemovalTimestamp', map: dateTimeFormatter },
    ];

    return (
        <ListCRUD
            resource='communicationProcesses'
            title={t('Transfers')}
            fields={fields}
            match={match}
            disableNewButton
            disableEditButton
        />
    );
};